import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';

const INK  = '#0A1F4A';
const INK2 = '#3D4F78';
const INK3 = '#7883A2';
const BG   = '#ECEEF3';
const SURF = '#FFFFFF';
const RULE = '#D6DAE4';
const ACC  = '#FF7A3D';

const POSTS = [
  {
    slug: '/blog/5-mistakes-first-eu-bid',
    tag: 'Best practice',
    date: 'March 2026',
    readTime: '7 min read',
    title: '5 mistakes to avoid when bidding on your first EU contract',
    excerpt: 'First-time bidders consistently make the same errors — from bidding on the wrong contracts to submitting at the last minute. Here is what to watch out for, and how to fix each one.',
  },
  {
    slug: '/blog/how-to-find-eu-tenders',
    tag: 'Guide',
    date: 'March 2026',
    readTime: '8 min read',
    title: 'How to find EU public tenders for your business',
    excerpt: 'TED, CPV codes, national portals, saved searches — a practical walkthrough of where EU procurement notices live and how to build a sustainable pipeline of relevant opportunities.',
  },
];

export default function Blog() {
  return (
    <div style={{ fontFamily: '"Geist", system-ui, -apple-system, sans-serif', background: BG, minHeight: '100vh' }}>

      {/* Hero */}
      <section style={{ background: BG, padding: '72px 24px 64px', textAlign: 'center', borderBottom: `1px solid ${RULE}` }}>
        <span style={{
          display: 'inline-block',
          fontFamily: '"JetBrains Mono", monospace',
          fontSize: 11, fontWeight: 600,
          letterSpacing: '0.14em', textTransform: 'uppercase',
          padding: '4px 10px',
          background: INK, color: ACC,
          borderRadius: 4,
          marginBottom: 20,
        }}>
          Blog
        </span>
        <h1 style={{
          fontSize: 48,
          fontWeight: 700,
          color: INK,
          lineHeight: 1.05,
          letterSpacing: '-0.025em',
          marginBottom: 16,
          maxWidth: 640,
          margin: '0 auto 16px',
        }}>
          Insights on EU public procurement
        </h1>
        <p style={{
          fontSize: 18,
          color: INK2,
          maxWidth: 480,
          margin: '0 auto',
          lineHeight: 1.6,
        }}>
          Practical guides, best practices, and market intelligence for companies bidding on EU contracts.
        </p>
      </section>

      {/* Post list */}
      <div style={{ maxWidth: 800, margin: '0 auto', padding: '64px 24px 80px' }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
          {POSTS.map((post) => (
            <Link
              key={post.slug}
              to={post.slug}
              style={{
                background: SURF,
                border: `1px solid ${INK}`,
                borderRadius: 18,
                padding: '28px 32px',
                textDecoration: 'none',
                display: 'block',
                transition: 'transform 220ms, box-shadow 220ms',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-4px)';
                e.currentTarget.style.boxShadow = `0 8px 0 ${INK}`;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'none';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 14 }}>
                <span style={{
                  display: 'inline-block',
                  fontFamily: '"JetBrains Mono", monospace',
                  fontSize: 10, fontWeight: 600,
                  letterSpacing: '0.12em', textTransform: 'uppercase',
                  padding: '3px 8px',
                  background: INK, color: ACC,
                  borderRadius: 3,
                }}>
                  {post.tag}
                </span>
                <span style={{ fontSize: 13, color: INK3 }}>
                  {post.date}&nbsp; · &nbsp;{post.readTime}
                </span>
              </div>
              <div style={{
                fontSize: 20,
                fontWeight: 700,
                color: INK,
                marginBottom: 10,
                lineHeight: 1.35,
              }}>
                {post.title}
              </div>
              <div style={{
                fontSize: 15,
                color: INK2,
                lineHeight: 1.7,
                marginBottom: 16,
              }}>
                {post.excerpt}
              </div>
              <div style={{
                fontSize: 14,
                fontWeight: 600,
                color: ACC,
              }}>
                Read article →
              </div>
            </Link>
          ))}
        </div>
      </div>

      <Footer />
    </div>
  );
}
